// External links banner
import React from 'react';

const ExternalLinksBanner = () => {
  return (
    <div className="info-banner">
        <div className='container'>
          <p>The reference URLs will take you to an external site that is not maintained by ENISA and we do not hold any responsibility on the content.</p>
        </div>
    </div>
  );
};

export default ExternalLinksBanner;